import styles from './SuggestionGrid.module.css';

function SuggestionGrid({ suggestions, onSuggestionClick }) {
  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  return (
    <div className={styles.suggestionContainer}>
      <h4 className={styles.suggestionTitle}>Try asking:</h4>
      <div className={styles.suggestionGrid}>
        {suggestions.map((s) => (
          <button
            key={s}
            onClick={() => onSuggestionClick(s)}
            className={styles.suggestionButton}
          >
            "{s}"
          </button>
        ))}
      </div>
    </div>
  );
}

export default SuggestionGrid;
